import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from 'app/components/ui/dialog';
import { Button } from 'app/components/ui/button';
import { useProductsSlice } from '../../slice';

import { Form } from 'app/components/ui/form';
import TagForm from '../form';
import { toast } from 'sonner';

interface DialogProductProps {
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
}

const DialogAddProductTag: React.FC<DialogProductProps> = ({
  isOpen,
  onClose,
}) => {
  const form = useForm();

  const { useAddProductsTagsMutation } = useProductsSlice();
  const [addTags, { isLoading, error, data }] = useAddProductsTagsMutation();

  const onSubmit = data => {
    addTags(data);
  };

  useEffect(() => {
    if (data) {
      toast.success(data?.message);
      onClose(false);
      form.reset();
    }
  }, [data, form]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.error);
    }
  }, [error]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Product Tags</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-4 p-4"
          >
            <TagForm />

            <DialogFooter className="pt-4 space-x-2">
              <Button
                variant="outline"
                onClick={() => {
                  onClose(false);
                }}
                className="p-2"
              >
                Cancel
              </Button>
              <Button type="submit" className="p-2" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save'}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAddProductTag;
